import { render, staticRenderFns } from "./CmsUsers.vue?vue&type=template&id=97b91312&scoped=true"
import script from "./CmsUsers.vue?vue&type=script&lang=ts"
export * from "./CmsUsers.vue?vue&type=script&lang=ts"
import style0 from "./CmsUsers.vue?vue&type=style&index=0&id=97b91312&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97b91312",
  null
  
)

export default component.exports